import React from "react";

import { Translate } from "@/app/application/Translate";
import { Checkbox, Switch } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
import { useField } from "formik";

type Props = {
	label: string;
	name: string;
	id: string;
	type?: string;
	placeholder?: string;
	translationString?: string;
	disabled?: boolean;
	/** When true, renders as a Switch (on/off) instead of a Checkbox */
	asSwitch?: boolean;
};

const StyledFormControlLabel = styled(FormControlLabel)`
	// CSS styles go here
`;

const CustomCheckbox = ({
	label,
	translationString,
	asSwitch,
	...props
}: Props) => {
	const [field, meta, helpers] = useField(props.name);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		helpers.setValue(event.target.checked);
	};

	const hasError = meta.touched && meta.error;

	const control = asSwitch ? (
		<Switch
			{...props}
			checked={Boolean(field.value)}
			onChange={handleChange}
			color="primary"
			size="medium"
		/>
	) : (
		<Checkbox {...props} checked={field.value} onChange={handleChange} />
	);

	return (
		<div className="input-container">
			<StyledFormControlLabel
				control={control}
				label={<Translate String={translationString || ""}>{label}</Translate>}
				labelPlacement={asSwitch ? "start" : undefined}
				className={hasError ? "input-error" : ""}
				sx={
					asSwitch
						? {
								color: "text.primary",
								m: 0,
								gap: 1,
								alignItems: "center",
								flexWrap: "nowrap",
								"& .MuiFormControlLabel-label": {
									marginRight: 0,
								},
							}
						: { color: "text.primary" }
				}
			/>
			{hasError && (
				<Typography
					variant="caption"
					sx={{ color: "error.main", mt: 0.5, display: "block" }}
				>
					{meta.error}
				</Typography>
			)}
		</div>
	);
};

export default CustomCheckbox;
